var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPCompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 22.0001C6.47703 22.0001 1.99988 17.5229 1.99988 12.0001C1.99988 6.47724 6.47703 2.00009 11.9999 2.00009C17.5227 2.00009 21.9999 6.47724 21.9999 12.0001C21.9999 17.5229 17.5227 22.0001 11.9999 22.0001ZM11.0025 16.0001L18.0736 8.92902L16.6594 7.51481L11.0025 13.1717L8.17409 10.3432L6.75987 11.7575L11.0025 16.0001Z",
    fill: "#38C793"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPCompleteIcon);
export default __webpack_public_path__ + "static/media/p-complete-icon.3103f95bbbc9eabf582b917b799d6b22.svg";
export { ForwardRef as ReactComponent };